import { IconButton } from '@presov.sk/presov-ui-react';
import Close from '@mui/icons-material/Close';
import { useSnackbar, type SnackbarKey } from 'notistack';
import React from 'react';

type Props = {
  snackbarId: SnackbarKey;
};

const SnackbarAction: React.FC<Props> = ({ snackbarId }) => {
  const { closeSnackbar } = useSnackbar();

  return (
    <IconButton
      size='small'
      onClick={() => closeSnackbar(snackbarId)}
      rounded
      clear
      sx={{
        '& svg': {
          color: (theme) => theme.palette.primary.contrastText,
        },

        '&:hover': {
          bgcolor: (theme) => theme.palette.primary.contrastText,

          '& svg': {
            color: (theme) => theme.palette.text.primary,
          },
        },
      }}
    >
      <Close />
    </IconButton>
  );
};

export default SnackbarAction;
